'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Chip } from '@common/components';
import { SvgTabMoreFold } from '@common/icon';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useState } from 'react';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { gtmDatasets } from '@/utils/analytics/gtm';
import type { CategoryOption } from '../types';
interface CategoryFilterProps {
  categoryId?: number;
  options: CategoryOption[];
  className?: string;
}
export const CategoryFilter = t0 => {
  const $ = _c(25);
  const {
    categoryId,
    options,
    className
  } = t0;
  const router = useCustomRouter();
  const [isFold, setIsFold] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== router) {
    t2 = giftCategoryId => {
      const currentSearchParams = new URLSearchParams(window.location.search);
      if (giftCategoryId) {
        currentSearchParams.set("categoryId", giftCategoryId.toString());
      } else {
        currentSearchParams.delete("categoryId");
      }
      router.replace(DONATION_ROUTES.GIFTS.withSearchParams({
        searchParams: Object.fromEntries(currentSearchParams)
      }));
    };
    $[1] = router;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  const t3 = !isFold;
  let t4;
  if ($[3] !== className || $[4] !== t3) {
    t4 = cn("relative z-[1] flex bg-Gray-white px-20 py-12", {
      "-mb-58 pb-20 border-b border-Gray-300 shadow-[0px_0px_8px_0px_rgba(0,0,0,0.04),0px_8px_10px_0px_rgba(0,0,0,0.05)]": t3
    }, className);
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== categoryId || $[7] !== emblaRef || $[8] !== handleClick || $[9] !== isFold || $[10] !== options) {
    t5 = isFold ? <div className="mx-0 overflow-hidden" ref={emblaRef}><div className="flex gap-6">{options.map(t6 => {
          const {
            value,
            label
          } = t6;
          return <div key={value} className="w-fit flex-[0_0_auto]"><Chip theme="primary" className="h-38" checked={value === 0 ? !categoryId : categoryId === value} onClick={() => handleClick(value)} {...gtmDatasets.clickTab({
              tab_name: label
            })}>{label}</Chip></div>;
        })}</div></div> : <ul className="flex flex-wrap items-center gap-6 gap-y-12 pr-62">{options.map(t7 => {
        const {
          value: value_0,
          label: label_0
        } = t7;
        return <li key={value_0}><Chip theme="primary" className="h-38" checked={value_0 === 0 ? !categoryId : categoryId === value_0} onClick={() => handleClick(value_0)} {...gtmDatasets.clickTab({
            tab_name: label_0
          })}>{label_0}</Chip></li>;
      })}</ul>;
    $[6] = categoryId;
    $[7] = emblaRef;
    $[8] = handleClick;
    $[9] = isFold;
    $[10] = options;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isFold) {
    t6 = () => setIsFold(!isFold);
    $[12] = isFold;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = !isFold;
  let t8;
  if ($[14] !== t7) {
    t8 = cn("size-24 duration-300 [filter:drop-shadow(0px_4px_5px_rgba(0,_0,_0,_0.03))_drop-shadow(0px_0px_3px_rgba(0,_0,_0,_0.03))]", {
      "-rotate-180 duration-300": t7
    });
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <SvgTabMoreFold originalFill={true} className={t8} />;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="absolute right-0 top-0 z-10 size-62 bg-[linear-gradient(90deg,rgba(255,255,255,0.00)_0%,#FFF_19.5%)] flex-center"><Button theme="sub-text" className="size-fit p-0" onClick={t6}>{t9}</Button></div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t5) {
    t11 = <section className={t4}>{t5}{t10}</section>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};